"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)("path", {
    d: "M256.9,171.6c-51.7,0.1-101.6,18.9-140.4,52.9l-55.4-55.2c-4-4.1-10.6-4.3-14.7-0.3c-2.1,2-3.2,4.7-3.2,7.6v137.1c0,11.5,9.3,20.8,20.8,20.8h137.1c5.8,0,10.4-4.6,10.5-10.4c0-2.9-1.1-5.6-3.2-7.6l-55.6-55.8c68.6-57.7,170.9-49,228.7,19.6c11.3,13.4,20.3,28.5,26.7,44.8c2,5.2,7.6,7.9,12.9,6.2l28.3-9.4c5.5-1.7,8.6-7.6,6.8-13.1c-0.1-0.2-0.1-0.3-0.2-0.5C424.3,226.1,345.2,171.7,256.9,171.6z"
  }));
};

exports.default = _default;